import request from "../interceptors/axios"

function login({ username, password }) {
  return request({
    url: "/auth/signin",
    method: "post",
    data: { username, password },
  })
}

function register({ username, password, email }) {
  return request({
    url: "/auth/signup",
    method: "post",
    data: { username, password, email },
  })
}

function getApis(params) {
  return request({
    url: "/apis",
    method: "get",
    params,
  })
}

function getApi(apiId) {
  return request({
    url: `/apis/${apiId}`,
    method: "get",
  })
}

function getImages() {
  return request({
    url: "/images",
    method: "get",
  })
}

function getModels({ imageApi }) {
  return request({
    url: `/apis/${imageApi}/models`,
    method: "get",
  })
}

function getStyles({ imageApi }) {
  return request({
    url: `/apis/${imageApi}/styles`,
    method: "get",
  })
}

function generate({ prompt, imageApi, modelId, styleName }) {
  return request({
    url: `/images`,
    method: "post",
    data: {
      prompt,
      api_id: imageApi,
      model_id: modelId,
      style_name: styleName,
    },
  })
}

function getDialogsId(chatApiId, dialogId) {
  return request({
    url: `/apis/${chatApiId}/dialogs/${dialogId}`,
    method: "get",
  })
}

function sendToChatApi({ chatApiId, contentId, dialogId, question }) {
  return request({
    url: `/apis/${chatApiId}/question`,
    method: "post",
    data: {
      question,
      content_id: contentId,
      dialog_id: dialogId,
    },
  })
}

//contents
function getContents(params) {
  return request({
    url: `/contents`,
    method: "get",
    params,
  })
}

function getContent(contentId) {
  return request({
    url: `/contents/${contentId}`,
    method: "get",
  })
}

function createContent(contentData) {
  return request({
    url: `/contents`,
    method: "post",
    data: contentData,
  })
}

function updateContent(contentId, contentData) {
  return request({
    url: `/contents/${contentId}`,
    method: "put",
    data: contentData,
  })
}

function deleteContent(contentId) {
  return request({
    url: `/contents/${contentId}`,
    method: "delete",
  })
}

//dialogs
function getDialogs({ apiId, params }) {
  return request({
    url: `/apis/${apiId}/dialogs`,
    method: "get",
    params,
  })
}

function updateDialog({ apiId, dialogId, data }) {
  return request({
    url: `/apis/${apiId}/dialogs/${dialogId}`,
    method: "put",
    data,
  })
}

function deleteDialog({ apiId, dialogId }) {
  return request({
    url: `/apis/${apiId}/dialogs/${dialogId}`,
    method: "delete",
  })
}

function logLoginOpen() {
  return request({
    url: `/log/login-opens`,
    method: "post",
  })
}

export default {
  login,
  register,
  getImages,

  getApis,
  getApi,

  getModels,
  getStyles,
  generate,

  sendToChatApi,
  getDialogsId,

  getContents,
  getContent,
  createContent,
  updateContent,
  deleteContent,

  getDialogs,
  updateDialog,
  deleteDialog,

  logLoginOpen,
}
